import type { ReactNode } from 'react';
import './page-header.css';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

/** Page title on the left, a cluster of small outlined controls on the right. */
export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div>
        <h1 className="page-header__title">{title}</h1>
        {description && <p className="page-header__desc">{description}</p>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </header>
  );
}
